// src/components/Testimonial.js
import React from 'react';
import '../styles/Testimonial.css';

const testimonials = [
  {
    name: "Ramesh Sharma",
    message: "This service was truly divine and respectful. The arrangements were done perfectly according to Hindu traditions.",
    location: "Vijayawada, India"
  },
  {
    name: "Sita Devi",
    message: "Very compassionate and timely service. It eased our pain during a difficult time.",
    location: "Vijayawada, India"
  },
  {
    name: "Amit Verma",
    message: "Excellent service with utmost respect to rituals. Highly recommended for traditional Hindu funeral rites.",
    location: "Vijayawada, India"
  }
];

function Testimonial() {
  return (
    <div className="testimonial-container">
      <h2 className="testimonial-title">Testimonials</h2>
      <p className="testimonial-subtitle">Testimonials from Our Customers</p>
      
      <div className="testimonial-list">
        {testimonials.map((testimonial, index) => (
          <div key={index} className="testimonial-card">
            <p className="testimonial-message">“{testimonial.message}”</p>
            <h4 className="testimonial-name">- {testimonial.name}</h4>
            <p className="testimonial-location">{testimonial.location}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Testimonial;
